import { LOCAL } from 'constants/environment';
import * as Sentry from '@sentry/react';

export const logIfDev = (...data: unknown[]): void => {
  if (LOCAL) {
    console.log(...data);
  }
};

export const logToSentry = (
  message: string,
  extra?: Record<string, unknown>,
): void => {
  if (!LOCAL) {
    Sentry.captureException(new Error(message), {
      level: 'fatal' as Sentry.SeverityLevel,
      extra,
    });
  } else {
    console.error(message, extra);
  }
};
